import pdfjsLib from './worker-loader';

interface PdfTextItem {
  str: string,
  hasEOL: boolean
}

// Thrown when the PDF is protected (bank statements often use part of the CPF as password)
export class PdfPasswordError extends Error {
  constructor(readonly incorrect: boolean) {
    super(incorrect ? 'Senha incorreta.' : 'O PDF é protegido por senha.');
  }
}

// Separates pages in the extracted text; it is whitespace, so parsers that collapse spaces ignore it
export const PAGE_BREAK = '\f';

// Text of every page, keeping the line breaks reported by pdf.js
export async function extractPdfText(file: Blob, password?: string): Promise<string> {
  const data = new Uint8Array(await file.arrayBuffer());
  const loadingTask = pdfjsLib.getDocument({ data, password });

  try {
    const pdf = await loadingTask.promise;

    const pages: string[] = [];
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const content = await page.getTextContent();
      pages.push((content.items as PdfTextItem[]).map(item => `${item.str}${item.hasEOL ? '\n' : ' '}`).join(''));
    }

    return pages.join(`\n${PAGE_BREAK}\n`).trim();
  } catch (error: any) {
    if (error?.name == 'PasswordException')
      throw new PdfPasswordError(error.code == pdfjsLib.PasswordResponses.INCORRECT_PASSWORD);
    throw error;
  } finally {
    await loadingTask.destroy();
  }
}
